import * as React from 'react';

const Monogram: React.FC<{ size: number }> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="currentColor" role="img" aria-label="Oracle Insight">
    <path
      fillRule="evenodd"
      d="M24 4.5 A19.5 19.5 0 1 0 24 43.5 A19.5 19.5 0 1 0 24 4.5 Z M24 9.5 A12 14.5 0 1 0 24 38.5 A12 14.5 0 1 0 24 9.5 Z"
    />
    <rect x="22.4" y="13.5" width="3.2" height="21" />
    <rect x="19.4" y="13.5" width="9.2" height="2.4" />
    <rect x="19.4" y="32.1" width="9.2" height="2.4" />
  </svg>
);

interface LogoProps {
  /** Mark height in px (default 36). Wordmark scales from this. */
  size?: number;
  /** 'mark' = monogram only; 'lockup' = monogram + wordmark (default). */
  variant?: 'mark' | 'lockup';
  /** 'reversed' = paper-colored, for use on dark/oxblood surfaces. */
  tone?: 'default' | 'reversed';
  showEyebrow?: boolean;
  eyebrow?: string;
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({
  size = 36,
  variant = 'lockup',
  tone = 'default',
  showEyebrow = false,
  eyebrow = 'Equity Research',
  className = '',
}) => {
  const markColor = tone === 'reversed' ? 'text-paper' : 'text-oxblood';
  const wordColor = tone === 'reversed' ? 'text-paper' : 'text-ink';
  const eyebrowColor = tone === 'reversed' ? 'text-paper/70' : 'text-ink-500';

  if (variant === 'mark') {
    return (
      <span className={`inline-flex ${markColor} ${className}`} aria-label="Oracle Insight">
        <Monogram size={size} />
      </span>
    );
  }

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className={`inline-flex shrink-0 ${markColor}`}>
        <Monogram size={size} />
      </span>
      <div className="flex flex-col leading-none">
        <span
          className={`font-serif font-medium tracking-tight ${wordColor}`}
          style={{ fontSize: Math.round(size * 0.52) }}
        >
          Oracle Insight
        </span>
        {showEyebrow && (
          <span
            className={`font-medium uppercase tracking-[0.2em] mt-1 ${eyebrowColor}`}
            style={{ fontSize: Math.max(9, Math.round(size * 0.26)) }}
          >
            {eyebrow}
          </span>
        )}
      </div>
    </div>
  );
};
